import { call, put, takeEvery } from 'redux-saga/effects';

import { captureException } from 'src/client/sentry';
import { graphql } from 'src/globals/api/requests';
import { promptToast } from 'src/components/toast-container/actions';
import {
  receiveShopPreference,
  shopPreferenceError,
  USER_LIKE_SHOP_REQUEST,
  USER_DISLIKE_SHOP_REQUEST,
} from '../actions';
import likeShopQuery from './queries/like-shop.graphql';
import dislikeShopQuery from './queries/dislike-shop.graphql';
import shopPreferenceStateQuery from './queries/shop-preference-state.graphql';

import type { likeShop, dislikeShop } from '../actions';

function* likeShopRequest({ shopId }: ReturnType<typeof likeShop>): any {
  try {
    const mutationResponse = yield call(() =>
      graphql(likeShopQuery, { shopId: `${shopId}` })
    );

    if (mutationResponse.errors && mutationResponse.errors.length) {
      yield call(captureException, mutationResponse.errors);
      yield put(
        promptToast(
          'error',
          window.APP_GLOBALS.t('account', 'shop-preference.request-error'),
          {
            toastId: `likeShop${shopId}`,
          }
        )
      );
      yield put(shopPreferenceError());
    } else {
      const stateResponse = yield call(() => graphql(shopPreferenceStateQuery));

      if (stateResponse.data) {
        yield put(receiveShopPreference(stateResponse.data));
      }
    }
  } catch (e) {
    yield call(captureException, e);
    yield put(
      promptToast(
        'error',
        window.APP_GLOBALS.t('account', 'shop-preference.request-error'),
        {
          toastId: `likeShop${shopId}`,
        }
      )
    );
    yield put(shopPreferenceError());
  }
}

function* dislikeShopRequest({ shopId }: ReturnType<typeof dislikeShop>): any {
  try {
    const mutationResponse = yield call(() =>
      graphql(dislikeShopQuery, { shopId: `${shopId}` })
    );

    if (mutationResponse.errors && mutationResponse.errors.length) {
      yield call(captureException, mutationResponse.errors);
      yield put(
        promptToast(
          'error',
          window.APP_GLOBALS.t('account', 'shop-preference.request-error'),
          {
            toastId: `dislikeShop${shopId}`,
          }
        )
      );
      yield put(shopPreferenceError());
    } else {
      const stateResponse = yield call(() => graphql(shopPreferenceStateQuery));

      if (stateResponse.data) {
        yield put(receiveShopPreference(stateResponse.data));
      }
    }
  } catch (e) {
    yield call(captureException, e);
    yield put(
      promptToast(
        'error',
        window.APP_GLOBALS.t('account', 'shop-preference.request-error'),
        {
          toastId: `dislikeShop${shopId}`,
        }
      )
    );
    yield put(shopPreferenceError());
  }
}

function* shopPreferenceSaga() {
  yield takeEvery(USER_LIKE_SHOP_REQUEST, likeShopRequest);
  yield takeEvery(USER_DISLIKE_SHOP_REQUEST, dislikeShopRequest);
}

export default shopPreferenceSaga;
